export default function fomatEmail(email: string) {
  return email.replace('@db1.com.br', '').replace('.', ' ');
}
